import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import styles from "./carousel-pagination.module.css";
var CarouselPagination = function(param) {
    var name = param.name, customClassNames = param.customClassNames;
    return /*#__PURE__*/ _jsx("div", {
        className: cx("".concat(name, "-pagination"), styles.pagination, customClassNames),
        "data-testid": "ds-carousel-pagination"
    });
};
export default CarouselPagination;
